
/**
 * 配置静态路由
 * 分为两种路由：
 * 1.路由出口在App.vue
 * 2.路由出口在main.vue
 */

// 1.路由出口在App.vue
const appRoutes = [
  // {
  //   // 设置初始页面
  //   path: '/',
  //   name: 'Home',
  //   component: () => import(/* webpackChunkName: "login" */ '../views/home/message.vue')
  // },
  {
    // 设置初始页面
    path: '',
    redirect: '/Home'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue')
  },
  {
    path: '/ArchaeologyHandset',
    name: 'ArchaeologyHandset',
    component: () => import(/* webpackChunkName: "login" */ '../views/handset/archaeology_handset.vue')
  },
  {
    path: '/404',
    name: '404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  }
]

/**
 * 路由出口在main.vue
 */
// const mainRoutes = [
//   {
//     path: '/Home',
//     name: 'Home',
//     component: () => import(/* webpackChunkName: "login" */ '../views/home/message.vue')
//   },
// ]

const mainRoutes = [

  {
    path: '/main',
    name: 'main-Home',
    title: '首页',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/main/Main.vue'),
    children: [
      {
        path: '/Home',
        name: 'home',
        title: '首页',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/home/Home.vue')
      },
      {
        path: '/Online-service',
        name: 'Online-service',
        title: '在线办事入口',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/OnlineService/OnlineService.vue')
      },
      {
        path: '/article/list',
        name: 'articleList',
        title: '文章列表',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/ArticleList.vue')
      },
      {
        path: '/article/listLeft',
        name: 'articleList',
        title: '文章列表',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/ArticleListLeft.vue')
      },
      {
        path: '/article/content',
        name: 'articleContent',
        title: '文章内容',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/ArticleContent.vue')
      },
      {
        path: '/home/Emergencies',
        name: 'Emergencies',
        title: '新型肺炎疫情防控专题',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/Emergencies.vue')
      },
      {
        path: '/Industry/Famous-historical',
        name: 'Famous-historical',
        title: '不可移动文物',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/Immovable/Famous-historical.vue')
      },
      {
        path: '/goverment-search-all',
        name: 'goverment-search-all',
        title: '全文检索',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/fullSearch/goverment-search-all.vue')
      },
      {
        path: '/goverment-search-release',
        name: 'goverment-search-release',
        title: '全文检索的详情页',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/fullSearch/release.vue')
      },
      {
        path: '/Industry/World-Heritage',
        name: 'World-Heritage',
        title: '中国世界文化遗产名录',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/Immovable/World-Heritage.vue')
      },
      {
        path: '/Industry/National-cultural',
        name: 'National-cultural',
        title: '中国重点文物保护单位名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/Immovable/National-cultural.vue')
      },
      {
        path: '/Industry/Collection-unit',
        name: 'CollectionUnit',
        title: '全国博物馆名录',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/museum/CollectionUnit.vue')
      },
      {
        path: '/Industry/Collection-Collection',
        name: 'Collection',
        title: '全国珍贵文物数据库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/museum/Collection.vue')
      },
      {
        path: '/Industry/Entry-exit',
        name: 'Entry-exit',
        title: '国家文物进出境审核管理处名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/Entry-exit.vue')
      },
      {
        path: '/Industry/Cultural-auction',
        name: 'Cultural-auction',
        title: '全国文物商店、文物拍卖企业名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/Cultural-auction.vue')
      },
      {
        path: '/Industry/Cultural-relics',
        name: 'Cultural-relics',
        title: '涉案文物鉴定评估机构名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/Cultural-relics.vue')
      },
      {
        path: '/Industry/foreign-cultural',
        name: 'foreign-cultural',
        title: '外国被盗文物数据库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/foreign-cultural.vue')
      },
      {
        path: '/Industry/Consultation-sh',
        name: 'Consultation-sh',
        title: '上海市民间收藏文物鉴定咨询推荐单位名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/Consultation-sh.vue')
      },
      {
        path: '/Industry/Folk-collection',
        name: 'Folk-collection',
        title: '民间收藏文物鉴定试点单位名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/SocialCulturalRelics/Folk-collection.vue')
      },
      {
        path: '/Industry/Revolution-Relic',
        name: 'Revolution-Relic',
        title: '革命文物保护利用片区分县名单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/Revolution-Relic/Revolution-Relic.vue')
      },
      {
        path: '/Industry/cul-protection-unit-info',
        name: 'unitDatabase',
        title: '全国文物保护工程资质单位数据库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/database/unitDatabase.vue')
      },
      {
        path: '/Industry/industry-supervision-management-search',
        name: 'personnelDatabase',
        title: '全国文物保护工程资格人员数据库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/database/personnelDatabase.vue')
      },
      {
        path: '/Industry/archaeological-excavation-database-search',
        name: 'archaeologyDatabase',
        title: '全国考古发掘资质单位数据库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/database/archaeologyDatabase.vue')
      },
      {
        path: '/home/gov-info-disclosure',
        name: 'gov-info-disclosure',
        title: '法律法规库',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/disclosure/disclosure.vue')
      },
      {
        path: '/home/gov-info-disc',
        name: 'gov-info-disc',
        title: '办件结果公开',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/disclosure/disc.vue')
      },
      {
        path: '/home/gov-info-disclo',
        name: 'gov-info-disclo',
        title: '专题文章',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/disclosure/disclo.vue')
      },
      {
        path: '/admin-license/exit-permits',
        name: 'exit-permits',
        title: '办事指南',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/article/exitPermits.vue')
      },
      {
        path: '/admin-license',
        name: 'adminLicense',
        title: '行政审批',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/license/adminLicense.vue')
      },
      {
        path: '/industry-manage',
        name: 'industryManage',
        title: '行业监管',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/industry/industryManage.vue')
      },

      {
        path: '/office-public',
        name: 'officePublic',
        title: '信息公开',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/information/OfficePublic.vue')
      },
      {
        path: '/public-service',
        name: 'publicService',
        title: '公共服务',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/service/PublicService.vue')
      },
      {
        path: '/home/supervision',
        name: 'supervision',
        title: '监管事项目录清单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/supervision/supervision.vue')
      },
      {
        path: '/enforce-notice',
        name: 'enforce-notice',
        title: '监管执法情况公示',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/enforce-notice/enforce-notice.vue')
      },
      {
        path: '/handle_result',
        name: 'handle_result',
        title: '监管事项目录清单',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/home/subtable/handle_result.vue')
      },
      {
        path: '/policy',
        name: 'policy',
        title: '法律法规',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/policy/policy.vue')
      },
      {
        path: '/standard',
        name: 'standard',
        title: '标准规范',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/standard/standard.vue')
      },
      {
        path: '/Opinion',
        name: 'Opinion',
        title: '系统建议',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/Opinion/Opinion.vue')
      },
      {
        path: '/notice',
        name: 'notice',
        title: '系统通知',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/notice/notice.vue')
      },
    ]
  },
  {
    path: '/IndividualRegistration',
    name: 'IndividualRegistration',
    title: '个人注册',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/IndividualRegistration/IndividualRegistration.vue'),
  },
  {
    path: '/RegisterLPStep',
    name: 'RegisterLPStep',
    title: '法人登录',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/RegisterLPStep/RegisterLPStep.vue'),
  },
  {
    path: '/pdfStandard',
    name: 'pdfStandard',
    title: 'pdf页面',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/standard/pdfStandard.vue'),
  },

]

// 汇总所有的路由
const staticRoutes = [...appRoutes, ...mainRoutes]

export { staticRoutes }
